const mailchimp = () => {

    $('#gdpr-label').on('click', function (e) {
        e.preventDefault();
        let childInput = $(this).find('input');
        if ($(this).hasClass('checked')) {
            childInput.prop('checked', false);
            $(this).removeClass('checked');
        } else {
            childInput.prop('checked', true);
            $(this).addClass('checked');
        }
    });

    let loader = '<div class="loader"><div class="ball-clip-rotate"><div></div></div></div>';

    // Changes for the landing page
    $(document).on('click tap touchstart', '#signup-button', function (e) {
        e.preventDefault();
        let email = $('#email').val();
        let message = $('#message');
        message.html('');
        if ($('#gdpr').is(':checked') && email.length > 0) {

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: {
                    action: 'mailchimp',
                    email: email,
                },
                beforeSend: function () {
                    message.removeClass('success');
                    message.removeClass('error');
                    $('#signup').hide();
                    $('#loader').html(loader);
                },
                success: function (data) {
                    data = JSON.parse(data);
                    $('#loader .loader').remove();
                    message.addClass('success');
                    message.html(data.message);
                },
                error: function (data) {
                    data = JSON.parse(data);
                    $('#loader .loader').remove();
                    message.addClass('error');
                    message.html(data.message );
                }
            });
            return false;
        } else {
            message.removeClass('success');
            message.addClass('error');
            message.html('<p>Please make sure email is correct and the permissions checkbox is checked.</p>');
        }
    });
}